const router = [
  {
    path: '/folder',
    name: 'folder',
    redirect: '/folder/list',
    component: () => import('@/modules/Folders/pages'),
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/modules/Folders/pages/Folders'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 82
        }
      },
      {
        path: 'create',
        name: 'create',
        component: () => import('@/modules/Folders/pages/FoldersABM'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 82
        }
      },
      {
        path: ':id',
        name: 'update',
        component: () => import('@/modules/Folders/pages/FoldersABM'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 82
        }
      },
      {
        path: ':id/subfolder',
        name: 'subfolder',
        component: () => import('@/modules/Folders/pages/SubFolder'),
        redirect: ':id/subfolder/list',
        children: [
          {
            path: 'list',
            name: 'subFolderList',
            component: () => import('@/modules/Folders/components/SubFolder'),
            meta: {
              requiresAuth: true,
              requiresPermission: true,
              action: 82
            }
          },
          {
            path: 'create',
            name: 'subFolderCreate',
            component: () => import('@/modules/Folders/pages/SubFoldersABM'),
            meta: {
              requiresAuth: true,
              requiresPermission: true,
              action: 82
            }
          },
          {
            path: ':subfolder',
            name: 'subFolderUpdate',
            component: () => import('@/modules/Folders/pages/SubFoldersABM'),
            meta: {
              requiresAuth: true,
              requiresPermission: true,
              action: 82
            }
          }
        ]
      }
    ]
  }
]
export default router
